import { Component, Input } from '@angular/core';
import { SharedDataService } from 'src/app/shared/services/registration.service';
import { UtilService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss']
})
export class EventComponent {

  @Input() event: any;

  constructor(private sharedDataService: SharedDataService, 
      private scrollService: UtilService){
  }
  eventRegister(){
    this.sharedDataService.sendData(this.event);
    this.scrollService.triggerScroll('scrollToRegister');
  }
}
